module.exports = __webpack_public_path__ + "img/logo_contractor.43cd6c12.png";